var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.width }),attrs:{"disabled":_vm.disabled,"size":"small","options":_vm.deptTree,"props":_vm.cascProps,"clearable":"","filterable":"","placeholder":"请选择"},model:{value:(_vm.resultValue),callback:function ($$v) {_vm.resultValue=$$v},expression:"resultValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }